<button
  [type]="type()"
  [disabled]="disabled()"
  class="sz-button"
  [class.sz-button--primary]="variant() === 'primary'"
  [class.sz-button--secondary]="variant() === 'secondary'"
  [class.sz-button--ghost]="variant() === 'ghost'"
  [class.sz-button--danger-ghost]="variant() === 'danger-ghost'"
  [class.sz-button--sm]="size() === 'sm'"
  [class.sz-button--full]="fullWidth()">
  <ng-content />
</button>
